/**
 * @generated SignedSource<<ba12f96bba69e2390e714bb8b099e6cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageSectionId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "pageSectionId",
    "variableName": "pageSectionId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "answersCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "participationRatio",
      "storageKey": null
    }
  ],
  "type": "ParticipativeModuleResultsFormField",
  "abstractKey": "__isParticipativeModuleResultsFormField"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowDisplayingPatternFill",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "chartLabel",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "colors",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v8 = [
  (v3/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v4/*: any*/),
      (v5/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "chartHint",
        "storageKey": null
      },
      (v6/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "showValues",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sortByValue",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ParticipativeModuleResultsFormFieldResultsOptionAnswersCount",
        "kind": "LinkedField",
        "name": "results",
        "plural": true,
        "selections": [
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "ParticipativeModuleResultsFormFieldChoices",
    "abstractKey": "__isParticipativeModuleResultsFormFieldChoices"
  }
],
v9 = [
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "categories",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ParticipativeModuleResultsFormFieldResultsSeries",
    "kind": "LinkedField",
    "name": "series",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      },
      (v2/*: any*/)
    ],
    "storageKey": null
  },
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ParticipativeModuleResultsFormFieldsQuery",
    "selections": [
      {
        "alias": "results",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "participativeModuleResultsFormFields",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ParticipativeModuleResultsFormField_result"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ParticipativeModuleResultsFormFieldsQuery",
    "selections": [
      {
        "alias": "results",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "participativeModuleResultsFormFields",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isParticipativeModuleResultsFormField"
          },
          {
            "kind": "InlineFragment",
            "selections": (v8/*: any*/),
            "type": "ParticipativeModuleResultsFormFieldPie",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v8/*: any*/),
            "type": "ParticipativeModuleResultsFormFieldBar",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v9/*: any*/),
            "type": "ParticipativeModuleResultsFormFieldStacked",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v9/*: any*/),
            "type": "ParticipativeModuleResultsFormFieldStackedAbsolute",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v9/*: any*/),
            "type": "ParticipativeModuleResultsFormFieldMultiBar",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clusterLabel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "resetZoomLabel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ParticipativeModuleResultsFormFieldResultsLocation",
                "kind": "LinkedField",
                "name": "data",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "latitude",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "longitude",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "type": "ParticipativeModuleResultsFormFieldMap",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tooltipMentionsLabel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tooltipContributionsLabel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ParticipativeModule",
                "kind": "LinkedField",
                "name": "participativeModule",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slug",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ParticipativeModuleResultsFormFieldResultsWordCloudWord",
                "kind": "LinkedField",
                "name": "words",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "text",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "weight",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "frequency",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "type": "ParticipativeModuleResultsFormFieldWordCloud",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6aa5d937984d5f5468926124271ed9e1",
    "id": null,
    "metadata": {},
    "name": "ParticipativeModuleResultsFormFieldsQuery",
    "operationKind": "query",
    "text": "query ParticipativeModuleResultsFormFieldsQuery(\n  $pageSectionId: ID!\n) {\n  results: participativeModuleResultsFormFields(pageSectionId: $pageSectionId) {\n    __typename\n    id\n    ...ParticipativeModuleResultsFormField_result\n  }\n}\n\nfragment ParticipativeModuleResultsFormFieldBar_result on ParticipativeModuleResultsFormFieldBar {\n  ...ParticipativeModuleResultsFormFieldContainer_result\n  ...ParticipativeModuleResultsFormFieldChoicesChart_result\n}\n\nfragment ParticipativeModuleResultsFormFieldChoicesChart_result on ParticipativeModuleResultsFormFieldChoices {\n  __isParticipativeModuleResultsFormFieldChoices: __typename\n  allowDisplayingPatternFill\n  chartLabel\n  chartHint\n  colors\n  showValues\n  sortByValue\n  results {\n    label\n    value\n    id\n  }\n}\n\nfragment ParticipativeModuleResultsFormFieldContainer_result on ParticipativeModuleResultsFormField {\n  __isParticipativeModuleResultsFormField: __typename\n  id\n  title\n  answersCount\n  participationRatio\n}\n\nfragment ParticipativeModuleResultsFormFieldMap_result on ParticipativeModuleResultsFormFieldMap {\n  colors\n  color\n  clusterLabel\n  resetZoomLabel\n  data {\n    label\n    latitude\n    longitude\n    id\n  }\n  ...ParticipativeModuleResultsFormFieldContainer_result\n}\n\nfragment ParticipativeModuleResultsFormFieldMultiBar_result on ParticipativeModuleResultsFormFieldMultiBar {\n  allowDisplayingPatternFill\n  chartLabel\n  colors\n  categories\n  series {\n    name\n    data\n    id\n  }\n  ...ParticipativeModuleResultsFormFieldContainer_result\n}\n\nfragment ParticipativeModuleResultsFormFieldPie_result on ParticipativeModuleResultsFormFieldPie {\n  ...ParticipativeModuleResultsFormFieldContainer_result\n  ...ParticipativeModuleResultsFormFieldChoicesChart_result\n}\n\nfragment ParticipativeModuleResultsFormFieldStackedAbsolute_result on ParticipativeModuleResultsFormFieldStackedAbsolute {\n  allowDisplayingPatternFill\n  chartLabel\n  colors\n  categories\n  series {\n    name\n    data\n    id\n  }\n  ...ParticipativeModuleResultsFormFieldContainer_result\n}\n\nfragment ParticipativeModuleResultsFormFieldStacked_result on ParticipativeModuleResultsFormFieldStacked {\n  allowDisplayingPatternFill\n  chartLabel\n  colors\n  categories\n  series {\n    name\n    data\n    id\n  }\n  ...ParticipativeModuleResultsFormFieldContainer_result\n}\n\nfragment ParticipativeModuleResultsFormFieldWordCloud_result on ParticipativeModuleResultsFormFieldWordCloud {\n  colors\n  tooltipMentionsLabel\n  tooltipContributionsLabel\n  participativeModule {\n    slug\n    id\n  }\n  words {\n    text\n    weight\n    frequency\n    id\n  }\n  ...ParticipativeModuleResultsFormFieldContainer_result\n}\n\nfragment ParticipativeModuleResultsFormField_result on ParticipativeModuleResultsFormField {\n  __isParticipativeModuleResultsFormField: __typename\n  __typename\n  ...ParticipativeModuleResultsFormFieldPie_result\n  ...ParticipativeModuleResultsFormFieldBar_result\n  ...ParticipativeModuleResultsFormFieldStacked_result\n  ...ParticipativeModuleResultsFormFieldStackedAbsolute_result\n  ...ParticipativeModuleResultsFormFieldMultiBar_result\n  ...ParticipativeModuleResultsFormFieldMap_result\n  ...ParticipativeModuleResultsFormFieldWordCloud_result\n}\n"
  }
};
})();

node.hash = "985e2f21243a8c37853398f4424ea351";

module.exports = node;
